<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTORENOVACION.LBL_RENOVACION' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioRenovacion" name="nomFormularioRenovacion">

      <div class="grid form-group">
        <div class="col-12 md:col-3 lg:col-3">
          <div class="div-form">
            <label>* {{ 'PRODUCTORENOVACION.LBL_FRECUENCIA' | translate }}</label>
            <p-dropdown disableTab  id="idFrecuencia" name="nomFrecuencia" [options]="lisFrecuencia"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idFrecuenciaProducto"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFrecuenciaProducto.invalid">
              {{ 'PRODUCTORENOVACION.LBL_FRECUENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <div class="div-form">
            <label>* {{ 'PRODUCTORENOVACION.LBL_PLAZOMINIMO' | translate }} ({{ 'LBL_MESES' | translate }})</label>
            <input type="text" pInputText id="idPlazoMinimo"
                   name="nomPlazoMinimo"
                   autocomplete="off"
                   formControlName="plazoMinimo" numero-entero-reactive
                   [maxlength]="2"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMinimo.invalid">
              {{ 'PRODUCTORENOVACION.LBL_PLAZOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <div class="div-form">
            <label>* {{ 'PRODUCTORENOVACION.LBL_PLAZOMAXIMO' | translate }} ({{ 'LBL_MESES' | translate }})</label>
            <input type="text" pInputText id="idPlazoMaximo"
                   name="nomPlazoMaximo"
                   autocomplete="off"
                   formControlName="plazoMaximo" numero-entero-reactive
                   [maxlength]="2"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMaximo.invalid">
              {{ 'PRODUCTORENOVACION.LBL_PLAZOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <div class="div-form">
            <label>* {{ 'PRODUCTORENOVACION.LBL_CUOTASPAGAR' | translate }}</label>
            <input type="text" pInputText id="idCuotasPagar"
                   name="nomCuotasPagar"
                   autocomplete="off"
                   formControlName="minimoCuotasPagas" numero-entero-reactive
                   [maxlength]="2"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.minimoCuotasPagas.invalid">
              {{ 'PRODUCTORENOVACION.LBL_CUOTASPAGAR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="cuoIncorrecto">
              {{ 'PRODUCTORENOVACION.MSG_DEBESTARRANGO' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTORENOVACION.LBL_PERFIL' | translate }}</label>
            <p-dropdown disableTab  id="idRiesgo" name="nomRiesgo" [options]="lisPerfiles"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idPerfilRiesgo"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPerfilRiesgo.invalid">
              {{ 'PRODUCTORENOVACION.LBL_PERFIL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTORENOVACION.LBL_NIVELAPRUEBA' | translate }}</label>
            <p-dropdown disableTab  id="idNivelAprueba" name="nomNivelAprueba" [options]="lisNivelAprueba" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="cargarNivelExcepcion($event.value)"
                         formControlName="idNivelAprueba"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNivelAprueba.invalid">
              {{ 'PRODUCTORENOVACION.LBL_NIVELAPRUEBA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTORENOVACION.LBL_NIVELEXCEPCION' | translate }}</label>
            <p-dropdown disableTab  id="idNivelExcepcion" name="nomNivelExcepcion" [options]="lisNivelExcepcion"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idNivelExcepcion"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNivelExcepcion.invalid">
              {{ 'PRODUCTORENOVACION.LBL_NIVELEXCEPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="proRenovacion.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando" #proRenovacion
                 [value]="lisProductosRenovaciones" selectionMode="single" dataKey="idProductoRenovacion"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreFrecuenciaProducto}}</td>
              <td>{{row.rangoPlazo}}</td>
              <td>{{row.minimoCuotasPagas}}</td>
              <td>{{row.perfilRiesgo}}</td>
              <td>{{row.nivelAprueba}}</td>
              <td>{{row.nivelExcepcion}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="renovacion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
